"use server"

import { signIn } from "@/auth"
import { prisma } from "@/lib/prisma"
import { AuthError } from "next-auth"

export async function googleSignIn() {
  await signIn("google", { redirectTo: "/portal" })
}

export async function credentialsLogin(
  _prev: { error: string } | null,
  formData: FormData,
): Promise<{ error: string } | null> {
  const email = (formData.get("email") as string)?.trim()
  const password = formData.get("password") as string

  if (!email || !password) return { error: "Email and password are required." }

  const user = await prisma.user.findUnique({ where: { email }, select: { role: true } })
  const redirectTo = user?.role === "SUPPORT" ? "/support" : "/portal"

  try {
    await signIn("credentials", { email, password, redirectTo })
  } catch (error) {
    if (error instanceof AuthError) {
      return { error: "Invalid email or password." }
    }
    throw error
  }
  return null
}
